import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface HeaderProps {
  onFormReset?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onFormReset }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  const isFrontPage = location.pathname === '/form';
  const headerClass = isFrontPage ? 'fixed-header' : '';

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      navigate('/login');
    }
  };

  const handleLogoClick = (e: React.MouseEvent) => {
    if (onFormReset && location.pathname === '/form') {
      e.preventDefault();
      const confirmReset = window.confirm('Vil du tilbakestille skjemaet? All data vil gå tapt.');
      if (confirmReset) {
        onFormReset();
      }
    }
  };

  const handleSkjemaClick = (e: React.MouseEvent) => {
    if (onFormReset && location.pathname === '/form') {
      e.preventDefault();
      const confirmReset = window.confirm('Vil du tilbakestille skjemaet? All data vil gå tapt.');
      if (confirmReset) {
        onFormReset();
      }
    }
  };

  if (!user) {
    return null; // Don't show header if not logged in
  }

  return (
    <div className={`main-header ${headerClass}`}>
      <div className="logo">
        <Link to="/form" onClick={handleLogoClick}>
          <span className="logo-text">PMSalg bestillingsskjema</span>
        </Link>
      </div>
      <ul>
        <li>
          <Link to="/form" onClick={handleSkjemaClick}>Skjema</Link>
        </li>
        <li>
          <Link to="/templates">Templates</Link>
        </li>
        <li>
          <Link to="/my-orders">Mine bestillinger</Link>
        </li>
        {user.role === 'administrator' && (
          <li>
            <Link to="/dashboard">Dashboard</Link>
          </li>
        )}
        <li>
          <Link to="/profile" className="user-info-link">
            {user.firstName} {user.lastName} ({user.role})
          </Link>
        </li>
        <li>
          <button onClick={handleLogout}>
            Logg ut
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Header;